import { UilSave, UilTimes } from '@iconscout/react-unicons';
import {
  Button,
  DialogTitle,
  Dialog,
  DialogContent,
  DialogActions,
  Notification,
  Grid,
} from '@xbotvn/mui';
import {
  filter, findIndex, get, includes, map, size,
} from 'lodash';
import PropTypes from 'prop-types';
import React, {
  useState,
  useEffect,
} from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { listingApi } from '../../api';
import {
  USER,
} from '../../redux/actions/constants';
import AddressSelector from '../AddressSelector';
import SingleSelect from '../SingleSelect';

export default function UnitSelector({
  onClose,
  user,
}) {
  const dispatch = useDispatch();

  const {
    unitsInitial,
    cities,
  } = useSelector(({
    unit,
    catalogs,
  }) => ({
    unitsInitial: unit.data,
    cities: catalogs.system.cities.data,
  }));
  const citiesLoaded = size(cities) > 0;
  const activeUnit = unitsInitial?.[user.activeUnit] || {};
  const {
    province,
    ward,
  } = activeUnit;
  const [selectedOption, setSelectedOption] = useState(user.activeUnit || '');
  const [unitOptions, setUnitOptions] = useState([]);
  const [address, setAddress] = useState({
    province,
    ward,
  });

  useEffect(() => {
    const {
      province: p,
      ward: w,
    } = address;
    if (citiesLoaded) {
      let filteredUnits = [];
      if (w) {
        filteredUnits = filter(unitsInitial, (unit) => unit?.ward === w);
      } else if (p) {
        filteredUnits = filter(unitsInitial, (unit) => unit?.province === p);
      }
      const unitExist = findIndex(filteredUnits, (unit) => unit._id === selectedOption);
      if (unitExist === -1) {
        setSelectedOption('');
      }
      setUnitOptions(filteredUnits);
    } else {
      setUnitOptions(unitsInitial);
    }
  }, [address]);

  return (
    <Dialog
      open
      onClose={onClose}
      fullWidth
      maxWidth="xl"
    >
      <DialogTitle>Chọn đơn vị</DialogTitle>
      <DialogContent>
        {citiesLoaded ? (
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <AddressSelector
                {...address}
                cities={cities}
                onAddressChange={(data) => {
                  setAddress(data);
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <SingleSelect
                options={
              map(unitOptions, ({
                _id: id, name,
              }) => ({
                value: id, label: name,
              }))
            }
                value={selectedOption}
                onChange={setSelectedOption}
              />
            </Grid>
          </Grid>
        ) : (
          <SingleSelect
            options={
              map(unitOptions, ({
                _id: id, name,
              }) => ({
                value: id, label: name,
              }))
            }
            value={selectedOption}
            onChange={setSelectedOption}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="success"
          startIcon={<UilSave />}
          onClick={async () => {
            if (!selectedOption) {
              Notification.warn('Bạn chưa chọn đơn vị.');
              return;
            }
            const selectedUnit = unitsInitial[selectedOption];
            const {
              result,
            } = await new Promise((resolve, reject) => {
              listingApi.checkInfo({
                collection: 'member',
                payload: {
                  data: {
                    email: user.email,
                    unitId: selectedOption,
                  },
                },
              }).then((res) => resolve(res.data))
                .catch((err) => reject(err));
            });

            if (!get(user, 'support', false)) {
              const check = includes(map(selectedUnit.members, (obj) => obj.email), user.email);
              if (!check && !result) {
                Notification.warn(`Bạn chưa được cấp quyền vào ${selectedUnit.name || ''}, liên hệ quản trị để được cấp quyền.`);
                return;
              }
            }
            dispatch({
              type: USER.handlers.update,
              data: {
                ...user,
                activeUnit: selectedUnit._id,
              },
              onSuccess: () => {
                Notification.success('Cập nhật đơn vị thành công.');
                window.location.reload();
              },
            });
          }}
          size="small"
        >
          Lưu
        </Button>
        <Button
          color="error"
          startIcon={<UilTimes />}
          onClick={onClose}
          style={{ marginLeft: 15 }}
          size="small"
        >
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
}

UnitSelector.propTypes = {
  onClose: PropTypes.func.isRequired,
  user: PropTypes.shape().isRequired,
};
